export const actionTypes = {
  SET_ASSESSMENTS: "SET_ASSESSMENTS",
  SET_SELECTED_ASSESSMENT: "SET_SELECTED_ASSESSMENT",
  SET_SELECTED_ASSESSMENT_ATTEMPTS: "SET_SELECTED_ASSESSMENT_ATTEMPTS",
  CLEAR_ASSESSMENTS: "CLEAR_ASSESSMENTS"
};
